import { Link } from 'react-router-dom';
import '../assets/styles/Slider.css';

function Slider() {
  const slides = [
    {
      title: 'Reliable Ocean Freight',
      description: 'Efficient and cost-effective ocean transport solutions.',
      image: '/assets/images/track-41.jpg',
      link: '/services/ocean-freight',
      ariaLabel: 'Learn more about our ocean freight services',
    },
    {
      title: 'Swift Air Freight',
      description: 'Fast and secure air transport for urgent shipments.',
      image: '/assets/images/track-17.jpg',
      link: '/services/air-freight',
      ariaLabel: 'Learn more about our air freight services',
    },
    {
      title: 'Cargo Express Delivery',
      description: 'Rapid and reliable express shipping for time-sensitive cargo.',
      image: '/assets/images/track-26.jpg',
      link: '/services/cargo-express',
      ariaLabel: 'Learn more about our cargo express delivery services',
    },
    {
      title: 'Secure Warehousing',
      description: 'Flexible storage solutions for your logistics needs.',
      image: '/assets/images/bg-about-22.jpg',
      link: '/services/warehousing',
      ariaLabel: 'Learn more about our warehousing solutions',
    },
    {
      title: 'Tailored Contract Logistics',
      description: 'Comprehensive logistics solutions customized to your business.',
      image: '/assets/images/blog-post-1.jpg',
      link: '/services/logistics',
      ariaLabel: 'Learn more about our contract logistics services',
    },
    {
      title: 'Global Reach, Local Expertise',
      description: 'Seamless logistics services connecting you worldwide.',
      image: '/assets/images/slider-loading-image1.jpg',
      link: '/about',
      ariaLabel: 'Learn more about our global logistics expertise',
    },
  ];

  return (
    <section aria-label="Featured Services Carousel">
      <div id="carouselExample" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`carousel-item ${index === 0 ? 'active' : ''}`}
              style={{ height: '400px' }}
            >
              <img
                src={slide.image}
                className="d-block w-100"
                style={{ height: '100%', objectFit: 'cover' }}
                alt={`Slide ${index + 1}: ${slide.title}`}
              />
              <div className="carousel-caption d-flex h-100 align-items-center justify-content-center">
                <div className="text-center">
                  <h2 className="display-4 fw-bold text-white">{slide.title}</h2>
                  <p className="text-white">{slide.description}</p>
                  <Link
                    to={slide.link}
                    className="btn btn-primary mt-3"
                    aria-label={slide.ariaLabel}
                  >
                    Learn More
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExample"
          data-bs-slide="prev"
          aria-label="Previous slide"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExample"
          data-bs-slide="next"
          aria-label="Next slide"
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
      <div className="bg-light py-4">
        <div className="container d-flex justify-content-between flex-wrap gap-3">
          <div className="d-flex align-items-center gap-2">
            <i className="bi bi-clock fs-5"></i>
            <span>Monday - Friday: 08:00 - 16:00</span>
          </div>
          <div className="d-flex align-items-center gap-2">
            <i className="bi bi-geo-alt fs-5"></i>
            <span>Mombasa, Nyerere Road at Palli House</span>
          </div>
          <div className="d-flex align-items-center gap-2">
            <i className="bi bi-telephone fs-5"></i>
            <span>+254 725 222 600</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Slider;